import {
    SET_LOCALE
} from './constants';

import i18n from '@/plugins/i18n'
import { DEFAULT_LOCALE } from '@/constants/i18n'
import { mapToI18nObject, sanitizeLocale } from '@/utils/i18n'
import { state } from './state'

import * as languageService from '@/services/language'

const actions = {

    setLocale({ commit }, payload) {
        //sanitize locale
        const desiredLocale = state.locales.find(locale => locale.id == payload.locale.toUpperCase());
        // Use a backup from the BE
        const backupLocaleBE = state.locales.find(locale => locale.id == DEFAULT_LOCALE.id);
        // Use a backup from the FE
        const backupLocaleFE = DEFAULT_LOCALE;

        const locale = desiredLocale || backupLocaleBE || backupLocaleFE;
        commit(SET_LOCALE, locale);
    },

    async fetchTranslations({ commit }, payload) {
        const { textType, filter, interactionToken, asFallback } = payload;
        if(!state?.locale?.language && !asFallback) {
            console.error("Fetching Translations before setting locales")
        }
        const language = state?.locale?.language || DEFAULT_LOCALE.language;
        
        try {
            const translations = await languageService.fetchTranslations(language, textType, filter, interactionToken)
            const texts = mapToI18nObject(translations);

            i18n.mergeLocaleMessage(language, texts);
            if(!asFallback) {
                i18n.locale = language;
            }
        } catch(e) {
            console.error(e)
            throw e
        }
    },

    async fetchLocales() {
        try {
            const locales = await languageService.fetchLocales()
            state.locales = locales;
        } catch(e) {
            console.error(e)
            throw e
        }
    },
}

export default actions
